import { render } from "./TagsFilterWidget.vue?vue&type=template&id=31b8799e&scoped=true"
import script from "./TagsFilterWidget.vue?vue&type=script&lang=js"
export * from "./TagsFilterWidget.vue?vue&type=script&lang=js"

import "./TagsFilterWidget.vue?vue&type=style&index=0&id=31b8799e&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b8799e"]])

export default __exports__